import React from 'react';
import Article from './Article';
import Subheading from './Subheading';
import Graf from './Graf';

export default function MerchantTermsOfService() {
  return (
    <Article
      title="Merchant Terms of Use"
      lastUpdated="January 28, 2021"
      asideTitle="contact"
      asideBody="support@saucey.com"
    >
      <Graf>
        BEFORE MERCHANT USES THE SAUCEY PLATFORM SERVICES PLEASE READ THESE
        TERMS OF USE (AS MAY BE MODIFIED OR UPDATED, <bold>“TERMS”</bold>)
        CAREFULLY. BY EXECUTING THE MERCHANT SIGN-UP AGREEMENT WITH SAUCEY (
        <strong>“SIGN-UP AGREEMENT”</strong>) OR USING THE SAUCEY PLATFORM
        SERVICES, MERCHANT AGREES TO BE BOUND BY THESE TERMS IN ADDITION TO THE
        TERMS OF THE EXECUTED SIGN-UP AGREEMENT.
      </Graf>
      <Graf>
        SECTION 17 OF THESE TERMS CONTAINS PROVISIONS THAT GOVERN HOW CLAIMS
        THAT THE PARTIES HAVE AGAINST EACH OTHER ARE RESOLVED, INCLUDING WITHOUT
        LIMITATION A MANDATORY ARBITRATION PROVISION.
      </Graf>
      <Graf>
        <strong>“Merchant”</strong> means the company identified within the
        Sign-Up Agreement.
        <strong>“Saucey”</strong> means Saucey, Inc., a Delaware corporation.
        “Agreement” means, collectively, the Sign-Up Agreement and these Terms.
        Capitalized terms used but not otherwise defined in these Terms shall
        have the respective meanings ascribed to such terms in the Sign-Up
        Agreement.
      </Graf>

      <Subheading>1. General</Subheading>

      <Graf>
        Merchant’s access to and use of the Saucey Platform Services is subject
        to the Agreement, and these Terms may be modified or updated by Saucey
        from time to time, effective upon posting an updated version of these
        Terms. The changes will not be retroactive, and the most current version
        of the Terms will be at https://www.saucey.com/merchant-terms Saucey
        will notify Merchants of material revisions via a service notification
        or an email to the email address associated with Merchant’s account. By
        continuing to access or use the Saucey Platform Services or Saucey App
        after those revisions become effective, Merchant agrees to be bound by
        the revised Terms. Merchant is responsible for updating contact
        information, Merchant information, and regularly reviewing the Terms for
        updates and information from Saucey. Continued use of the Saucey
        Platform Services after any such modifications or updates shall
        constitute Merchant’s consent to such changes. Saucey may restrict or
        rescind Merchant’s right to use the Saucey App and the Saucey Platform
        Services at any time in the event Saucey deems it necessary or
        appropriate.
      </Graf>

      <Subheading>2. The Parties Relationship</Subheading>
      <Graf>
        As described in the Sign-Up Agreement, Saucey is not a merchant or
        delivery service. Saucey is an online connection platform. Merchant and
        Saucey agree they are independent businesses whose relationship is
        governed by the Agreement. Nothing in the Parties’ agreements,
        relationship or transactions shall create or be construed as creating an
        agency, partnership, fiduciary or joint venture relationship between
        Saucey and Merchant, Saucey and a Delivery Driver, or Saucey and end
        consumers. Except as expressly set forth in the Agreement, each Party
        shall be responsible for its own expenses, profits and losses. Saucey
        reserves the right, at its sole discretion, to change, suspend, or
        discontinue the Saucey Platform Services and/or the Saucey App at any
        time. Merchant agrees to accept and receive communications from (and on
        behalf of) Saucey and the Delivery Drivers, including via email, text
        messages, calls, and push notifications including to the cellular
        telephone number(s) Merchant provides to Saucey.
      </Graf>

      <Subheading>3. Saucey Obligations</Subheading>
      <Graf>
        Subject to the terms and conditions of the Agreement, Saucey will make
        available the Saucey Platform Services and the Saucey App to Merchant,
        solely for use by Merchant at locations that are owned and operated by
        Merchant. For the avoidance of doubt, as between Merchant and Saucey,
        Saucey will retain sole and absolute control over the Saucey App (and
        all elements of the user experience and user interface relating to the
        Saucey App).
      </Graf>

      <Subheading>4. Merchant Obligations</Subheading>
      <ol type="a">
        <li>
          <Graf>
            Merchant will prepare, handle, and package all Merchant Delivery
            Products in accordance with applicable laws and regulations,
            including without limitation all laws, rules and regulations
            governing alcohol and tobacco, as applicable.
          </Graf>
        </li>
        <li>
          <Graf>
            Merchant acknowledges and agrees that neither Saucey nor the
            Delivery Driver takes title to (or acquires any ownership interest
            in) any Merchant Delivery Product at any time.
          </Graf>
        </li>
        <li>
          <Graf>
            In connection with the access to and use of the Saucey Platform
            Services and Saucey App, Merchant will not (and will not allow any
            third party to): (i) reverse engineer or attempt to discover any
            source code or underlying ideas or algorithms used to provide the
            Saucey Platform Services (except to the extent applicable law
            prohibits reverse engineering restrictions); (ii) provide, lease,
            lend, disclose, or otherwise use or allow others to use, in each
            case, for the direct benefit of any third party, the Saucey Platform
            Services (except as otherwise authorized by Saucey); or (iii)
            possess or use, or allow the transfer, transmission, export, or
            re-export of any software or portion thereof in violation of any
            export control laws or regulations administered by the U.S. Commerce
            Department, U.S. Treasury Department's Office of Foreign Assets
            Control, or any other government agency.
          </Graf>
        </li>
        <li>
          <Graf>
            Before Merchant may offer Merchant Delivery Products for sale via
            the Saucey App, Merchant shall provide copies of applicable Required
            Licenses (as defined herein) to Saucey. Merchant will (i)
            immediately notify Saucey of any change or modification to any of
            its Required Licenses (e.g., expiration, revocation, renewal,
            termination, etc.), and (ii) immediately provide Saucey with any new
            or updated Required Licenses.
          </Graf>
        </li>
        <li>
          <Graf>
            Merchant agrees to follow all laws and regulations related to its
            advertisement and promotion of Merchant Delivery Products, including
            but not limited to, only creating promotions that comply with
            applicable local laws, Alcohol and Tobacco Tax and Trade Bureau and
            Federal Trade Commission guidelines, and following industry best
            practices.
          </Graf>
        </li>
      </ol>
      <Subheading>
        5. Delivery Driver End Consumer Identification and Age Verification
      </Subheading>
      <Graf>
        Each Delivery Driver shall deliver the Merchant Delivery Products under
        and pursuant to Merchant’s Required Licenses and, as necessary, as
        Merchant’s third-party beneficiary. Merchant agrees that Delivery
        Drivers shall conduct the delivery and are therefore responsible for
        verifying the age and identity of the end consumers and confirming that
        the end consumers are not intoxicated when completing delivery. Saucey
        shall have a policy or other instruction with Delivery Drivers (either
        directly or through any applicable delivery service providers of
        Delivery Drivers) that requires Delivery Drivers to verify the age and
        identity of the end consumers and ensure the end consumer is not
        intoxicated, which the Delivery Drivers may perform through third party
        software or other tools and methods of the Delivery Drivers (including,
        where applicable or required by law, third party software that may
        enable the Delivery Person to capture a photo of the end consumer’s ID
        and signature).
      </Graf>
      <Subheading>6. Fees and Taxes</Subheading>
      <ol type="a">
        <li>
          <Graf>
            Fees and Calculation.
            <br /> The fees and charges Merchant shall pay Saucey are generally
            set forth in the Sign-Up Agreement, provided that in the event a
            particular fee or charge is set forth in the Terms and effective
            after the effective date of the Sign-Up Agreement, such fees or
            charges set forth in the Terms shall supersede and replace the
            referenced fee or charge, as the case may be, in the Sign-Up
            Agreement. For example, if the Saucey Provided Device Monthly Fee in
            the Sign-Up Agreement is $19 per month, and these Terms are
            thereafter modified and set forth a Saucey Provided Device Monthly
            Fee of $24 per month, then such modified $24 fee shall apply. For
            the avoidance of doubt, fees and charges set forth in the Terms (if
            any) are in addition to the fees and charges set forth in the
            Sign-Up Agreement, except to the extent the same fee or charge is
            referenced in both.
          </Graf>
        </li>
        <li>
          <Graf>
            Remittance. Saucey will remit to Merchant the total retail price
            collected for all Merchant Delivery Products sold by Merchant via
            the Saucey Platform Services (including any Taxes (as defined)
            collected on its behalf, except as otherwise set forth in Section 6e
            below) less applicable retained fees or charges and any refunds
            given to end consumers (unless to the extent such refund is covered
            by Saucey as expressly provided for in the Sign-Up Agreement),
            within 10 business days of the sale of the Merchant Delivery Product
            (subject to the foregoing, Saucey typically makes such payment on a
            daily basis approximately 5 business days after the sale).
          </Graf>
        </li>
        <li>
          <Graf>
            Deduction and Debit. Saucey may (and hereby authorized Saucey to)
            deduct any amounts owed by Merchant to Saucey (including, without
            limitation, fees, charges, reimbursements and damages) from the
            amounts payable by Saucey to Merchant. In addition to the foregoing,
            and the fullest extent permitted under applicable law, rules and
            regulations, Merchant authorizes Saucey to debit Merchant’s bank
            account on record for amounts owing by Merchant to Saucey. If any
            fee or charge is not paid in full by the due date, Saucey may assess
            interest on the unpaid amount for the period beginning on the due
            date and ending on the date that the amount is paid in full. The
            amount of interest to be paid shall not exceed the maximum rate
            under applicable law. In addition to the foregoing, and the fullest
            extent permitted under applicable law, rules and regulations,
            Merchant authorizes Saucey to debit Merchant’s bank account on
            record for amounts owing by Merchant to Saucey.
          </Graf>
        </li>
        <li>
          <Graf>
            Taxes. Subject to Section 6e below, Merchant shall be responsible
            for all taxes, duties and other governmental charges, including
            without limitation those related to alcohol, tobacco, general
            excise, gross receipts, sales taxes and sellers use (collectively,
            “Taxes”) on the sale of the Merchant Delivery Products and for
            remitting such taxes, duties and other governmental charges to the
            appropriate authorities. However, Merchant hereby authorizes Saucey
            to collect applicable Taxes on Merchant’s behalf based on
            information provided by Merchant through the Saucy App or otherwise.
            In the event that the Merchant raises the price for a Merchant
            Delivery Product on the Saucey App (or the tax, duty, or other
            governmental charge increases), Saucey shall not be required to
            remit the higher price to the Merchant until 3 business days after
            the Merchant first provides notice to Saucey of such pricing, tax,
            duty or other charge change.
          </Graf>
        </li>
        <li>
          <Graf>
            Marketplace Facilitator Laws and Procedures. Certain legislation
            commonly known as “marketplace facilitator” laws (“Marketplace
            Facilitator Laws”) may require Saucey to collect and remit sales
            Taxes directly to the taxing authority. In jurisdictions with
            Marketplace Facilitator laws in effect that are applicable to Saucey
            due to the Agreement (each a “Marketplace Facilitator Jurisdiction”
            beginning the effective date of such legislation), Saucey may
            determine, as of a date specified by Saucey (“Switchover Date(s)”),
            the amount of applicable sales Tax which Saucey will collect and
            remit to the taxing authority based on Item descriptions and
            additional information provided by Merchant. For the avoidance of
            doubt, for each Marketplace Facilitator Jurisdiction: (i) Saucey
            will continue to collect sales Taxes on behalf of, and remit such
            amounts to, Merchant until the applicable Switchover Date and (ii)
            beginning on the applicable Switchover Date, any covered sales Taxes
            will be collected by Saucey and remitted to the applicable tax
            authority on Saucey’s own account, and not on behalf of Merchant. A
            list of jurisdictions in which Saucey will collect and remit sales
            Taxes to taxing authorities (and associated Switchover Dates) will
            be provided by Saucy to Merchant upon Merchant’s reasonable request,
            and such list may be updated from time to time.
          </Graf>
        </li>
        <li>
          <Graf>
            Review of Transactions. Merchant agrees, on an ongoing basis, to
            review and confirm its transactions, fees and charges on orders and
            invoices relating to the Saucey Platform Services, and to promptly
            communicate to Saucey in writing any claimed inaccuracies, so that
            Saucey has the prompt opportunity to address and resolve any issues,
            which the Parties agree is in the best interests of both Parties.
            Merchant agrees to communicate to Saucey any disagreement,
            non-conformity or any issue with any transaction, fee, charge or
            order within 60 days of the transaction, fee or order. Merchant
            shall be deemed to have acquiesced in and ratified, and to have
            waived any claim or objection regarding, each transaction, fee,
            charge and order if Merchant does not communicate a written claim or
            objection to Saucey regarding such transaction, fee, charge or order
            within such 60-day period.
          </Graf>
        </li>
      </ol>

      <Subheading>7. Intellectual Property</Subheading>
      <Graf>
        Subject to the Agreement, each Party hereby grants to the other Party
        (and, in the case of Saucey, to its affiliates) a limited, non-exclusive
        and non-transferable license during the Term to use such Party’s
        respective Marks in the territory of the USA, on a royalty-free basis,
        in connection with the activities related to the Agreement or any other
        activities relating to the Saucey Platform Services. For purposes of
        this Agreement, the term “Marks” will mean the trademarks, service
        marks, trade names, copyrights, logos, slogans, content, media,
        materials, identifying symbols and indicia of the applicable Party. All
        uses of a Party’s Marks by the other party will be in the form and
        format specified or approved by the owner of such marks. Other than as
        specifically set forth in the Agreement, neither party will use the
        other Party’s Marks without the prior, express, written consent of the
        other Party (by email is sufficient). For the avoidance of doubt,
        however, any use or display of Merchant’s Marks by Saucey or its
        affiliates in connection with making Merchant Delivery Products
        available through the Saucey Platform Services or Saucey App in the
        ordinary course of business will not require any such prior, express,
        written consent. All goodwill related to the use of a Party’s Marks by
        the other Party will inure to the benefit of the owner of such Marks.
        Except as expressly set forth herein, neither Party will be deemed to
        grant the other Party any license or rights under any intellectual
        property or other proprietary rights. All rights not granted are
        expressly reserved. Without limiting anything in the Agreement, Merchant
        represents and warrants that Merchant’s Marks do not infringe,
        misappropriate, or otherwise violate any third party’s intellectual
        property or other proprietary rights. Merchant agrees that Saucey may
        remove Merchant’s Marks from the Saucey App if Saucey receives notice or
        otherwise reasonably believe that such Merchant’s Marks may infringe,
        misappropriate, or otherwise violate any intellectual property or other
        proprietary rights.
      </Graf>
      <Subheading>8. Confidential Information</Subheading>
      <ol type="a">
        <li>
          <Graf>
            The term “Confidential Information” shall mean any confidential or
            proprietary business, technical or financial information or
            materials of a Party (“Disclosing Party”) provided to the other
            Party (“Receiving Party”) in connection with this Agreement, whether
            orally or in physical form, and shall include the terms of the
            Agreement. Without limiting the foregoing, any information that
            Saucey provides or makes accessible to Merchant through the Saucey
            Platform Services or Saucey App, including without limitation, data
            relating to the Saucey Analytical Services is the Confidential
            Information of Saucey (“Saucey Data”).
          </Graf>
        </li>
        <li>
          <Graf>
            Confidential Information does not include information that: (i) was
            rightfully known to the Receiving Party without restriction on use
            or disclosure prior to such information being disclosed to the
            Receiving Party in connection with the Agreement; (ii) was or
            becomes public domain other than by the fault of the Receiving
            Party; (iii) was or is received by the Receiving Party on a
            non-confidential basis from a third party that, to the Receiving
            Party's knowledge, was not at the time under any obligation to
            maintain its confidentiality; or(iv) the Receiving Party can
            demonstrate by documentary records was independently developed by
            the Receiving Party without access to, use of or reference to any
            Confidential Information.
          </Graf>
        </li>
        <li>
          <Graf>
            The Receiving Party shall: (i) not access or use Confidential
            Information other than as necessary to exercise its rights or
            perform its obligations in accordance with this Agreement; (ii)
            except subject to its compliance with the immediately following
            sentence, not disclose or permit access to Confidential Information
            other than to its or any of its affiliates, employees, officers,
            directors, consultants, agents, independent contractors, service
            providers, subcontractors and legal advisors (“Representatives”) who
            need to know such Confidential Information for purposes of the
            Receiving Party's exercise of its rights or performance of its
            obligations under and in accordance with this Agreement, and prior
            to any such disclosure are bound by written confidentiality and
            restricted use obligations at least as protective of the
            Confidential Information as the terms set forth in this Section; and
            (iii) safeguard the Confidential Information from unauthorized use,
            access or disclosure using at least the degree of care it uses to
            protect its most/similarly sensitive information and in no event
            less than a reasonable degree of care. If the Receiving Party is
            compelled by applicable law or rule of court to disclose any
            Confidential Information then, to the extent permitted by applicable
            law or rule of court, the Receiving Party shall promptly notify the
            Disclosing Party in writing of such requirement so that the
            Disclosing Party can seek a protective order or other remedy or
            waive its rights under this Section and provide reasonable
            assistance to the Disclosing Party, at the Disclosing Party's sole
            expense, in opposing or seeking protective limitations on
            disclosure.
          </Graf>
        </li>
      </ol>
      <Subheading>
        9. Personal Information, Data Privacy and Security
      </Subheading>
      <ol type="a">
        <li>
          <Graf>
            “Personal Information” shall mean any information exchanged under,
            or obtained in connection with, the Agreement that (i) identifies or
            can be used to identify an individual (including without limitation,
            names, telephone numbers, addresses, signatures, email addresses or
            other unique identifiers); or (ii) can reasonably be used to
            authenticate an individual (including without limitation, name,
            contact information, precise location information, access
            credentials, persistent identifiers and any information that may be
            considered ‘personal data’ or ‘personal information’ under
            applicable law).
          </Graf>
        </li>
        <li>
          <Graf>
            General. Merchant agrees not to access, collect, store, retain,
            transfer, use or otherwise process in any manner Saucey Data,
            including without limitation Personal Information, except as
            required to perform under the Agreement. Merchant shall keep Saucey
            Data secure from unauthorized access and maintain the accuracy and
            integrity of Saucey Data in Merchant’s custody or control by using
            appropriate organizational, physical and technical safeguards. If
            Merchant becomes aware of any unauthorized access to Saucey Data,
            Merchant will immediately notify Saucey, consult and cooperate with
            investigations and potentially required notices, and provide any
            information reasonably requested by Saucey. Merchant agrees to
            implement and use security procedures, protocols or access
            credentials as reasonably requested by Saucey and will be
            responsible for damages resulting from Merchant’s failure to comply.
            Merchant will not allow any third party to use the Saucey Platform
            Services or the Saucey App and will be responsible for damages
            resulting from sharing Merchant’s login credentials with
            unauthorized third parties or otherwise permitting unauthorized
            access to Merchant’s account. Merchants may not: (i) allow any third
            party to copy, modify, rent, lease, sell, distribute, reverse
            engineer, or otherwise attempt to gain access to the source code of
            the Saucey Platform Services or the Saucey App; (ii) damage, destroy
            or impede the Saucey Platform Services or Saucey App; (iii) transmit
            injurious code; or (iv) bypass or breach any security protection on
            the Saucey Platform Services or Saucey App.{' '}
          </Graf>
        </li>
        <li>
          <Graf>
            Saucey App. During the Term, Saucey grants to Merchant a
            non-exclusive, royalty-free, non-assignable, non-transferable,
            non-sublicensable, revocable, limited, fully paid-up license to
            access the Saucey App solely to transmit information to facilitate
            business through the Saucey Platform Services. Merchant will not and
            will not permit or authorize any third party to (i) sell, license,
            rent, resell, lease, assign (except as permitted herein), transfer,
            or otherwise commercially exploit the Saucey App; (ii) circumvent or
            disable any security or other technological features or measures of,
            or otherwise gain or attempt to gain unauthorized access to the
            Sauce App; (iii) reverse engineer, dissemble, decompile, or
            otherwise attempt to derive the source code or the underlying ideas,
            algorithms, structure, or organization of the Saucey App; (iv) use
            the Saucey App in any manner or for any purpose that violates any
            law or regulation; and (v) use the Saucey App for a reason other
            than as specifically provided or intended under the Agreement. Each
            Party agrees not to perform any action with the intent of
            introducing to the other Party’s systems, products, or services
            (including the Saucey App) any viruses, worms, defects, Trojan
            horses, malware, or any items of a destructive nature.
          </Graf>
        </li>
      </ol>
      <Subheading>10. Payment Processing</Subheading>
      <Graf>
        Payment processing services for Merchant’s sale of Merchant Delivery
        Products through the Saucey Platform Services are provided by Stripe and
        are subject to certain terms of use and other agreements with Stripe,
        all of which Merchant agrees to be bound by. These Stripe terms of use
        and other agreements include the Stripe Connected Account Agreement
        (https://stripe.com/connect-account/legal), which includes the Stripe
        Services Agreement (https://stripe.com/legal). By agreeing to these
        Terms, Merchant agrees to be bound by the Stripe Connected Account
        Agreement and the Stripe Services Agreement, as the same may be modified
        by Stripe from time to time. As a condition of Saucey enabling payment
        processing services through Stripe, Merchant agrees to provide Saucey
        accurate and complete information about Merchant’s representative and
        its business, and Merchant authorizes Saucey to share it and transaction
        information related to Merchant’s use of the payment processing services
        provided by Stripe. Stripe has been audited by a PCI-certified auditor
        and is certified to PCI Service Provider Level 1. Saucey, at its sole
        discretion, may change the payment processing provider from time to time
        upon notice to Merchant (including through an updated or modified
        Terms).
      </Graf>
      <Subheading>11. Representations and Warranties; Disclaimer</Subheading>
      <ol type="a">
        <li>
          <Graf>
            Representations and Warranties. Each Party hereby represents and
            warrants that: (i) it has full power and authority to enter into the
            Agreement and perform its obligations hereunder and thereunder; (ii)
            it is duly organized, validly existing and in good standing under
            the laws of the jurisdiction of its origin; (iii) it has not entered
            into, and during the Term will not enter into, any agreement that
            would prevent it from complying with or performing under the
            Agreement; (iv) it will comply with all applicable laws and
            regulations in the performance of this Agreement and any activities
            hereunder (including all applicable consumer protection, data
            protection and privacy laws and, in the case of Merchant, all
            applicable laws, rules and regulations governing the sale,
            promotion, taxation and delivery of, as applicable, alcohol and
            tobacco); and (v) it will comply with all applicable laws related to
            third party intellectual property and other proprietary rights. In
            addition, Merchant represents and warrants that it has and will
            continue to have during the Term all licenses, permits, or similar
            authorizations that may be required for it to sell alcohol or
            tobacco Merchant Delivery Products (“Required Licenses”), including
            without limitation, Required Licenses for the specific categories of
            alcohol and tobacco Merchant Deliver Products and/or Required
            Licenses to sell and deliver alcohol and tobacco items in a given
            state or local jurisdiction.
          </Graf>
        </li>
        <li>
          <Graf>
            Disclaimer. EXCEPT AS EXPRESSLY SET FORTH HEREIN, TO THE EXTENT
            PERMITTED BY APPLICABLE LAW, SAUCEY HEREBY EXPRESSLY DISCLAIMS ALL
            WARRANTIES, EXPRESS, IMPLIED OR STATUTORY, REGARDING THE SAUCEY
            PLATFORM SERVICES, THE SAUCEY APP, THE SAUCEY ANALYTICAL SERVICES,
            OR THE SAUCEY PROVIDED DEVICES, INCLUDING BUT NOT LIMITED TO ANY
            IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, SATISFACTORY QUALITY
            OR RESULTS, OR FITNESS FOR A PARTICULAR PURPOSE AND
            NON-INFRINGEMENT. Merchant acknowledges that the operation of the
            Saucey Platform Services and Saucey App may from time to time
            encounter technical or other problems and may not necessarily
            continue uninterrupted or without technical or other errors and
            Saucey shall not be responsible to Merchant or others for any such
            interruptions, errors, or problems or an outright discontinuance of
            the Saucey Platform Services or Saucey App nor for any guarantee of
            results with respect to the Saucey Platform Services or the Saucey
            App. Both Parties acknowledge that neither Party has any expectation
            or has received any assurances for future business or that any
            investment by a Party will be recovered or recouped or that such
            Party will obtain any anticipated amount of profits by virtue of the
            Agreement.
          </Graf>
        </li>
      </ol>
      <Subheading>12. Indemnity</Subheading>
      <Graf>
        Indemnity. Each Party (“Indemnifying Party”) will indemnify, defend and
        hold harmless the other, its affiliates and respective directors,
        officers, employees and agents (the “Indemnified Party”) from and
        against any and all claims, damages, liabilities, causes of action, and
        losses (including reasonable attorney’s fees) (collectively, “Losses”)
        with respect to any third party claim arising out of or related to: (i)
        the negligence or willful misconduct of the Indemnifying Party or its
        employees or agents in their performance of the Agreement; (ii) any
        claims that, if true, would be a breach of any of the Indemnifying
        Party’s representations, warranties or covenants in the Agreement; or
        (iii) any claims that the Marks provided by the Indemnifying Party
        infringe a third party’s intellectual property rights, to the extent the
        Indemnified Party used such Marks in accordance with the manner approved
        by the Indemnifying Party. In addition, Merchant will indemnify, defend
        and hold harmless the Saucey Indemnified Parties from and against any
        and all Losses with respect to any third party claim arising out of or
        related to: (A) Merchant’s violation or alleged violation of any
        applicable law, code, rule or regulation related to the sale, promotion,
        taxation and/or delivery of alcohol and/or tobacco products; (B) Tax
        applicable to sales of Merchant Delivery Products (except for sales Tax
        in any Marketplace Facilitator Jurisdictions after the applicable
        Switchover Date); or (C) Merchant’s failure to provide accurate and
        complete information of Merchant or descriptions for Merchant Delivery
        Products, except in the case of each of (A)-(C) above, to the extent
        such harm was directly caused by the gross negligence or willful
        misconduct of Saucey or its employees, agents or the Delivery Drivers.
        In each case the Indemnified Party shall provide the Indemnifying Party
        with (a) prompt notice of any claims such that the Indemnifying Party is
        not prejudiced by any delay of such notification, (b) the option to
        assume sole control over defense and settlement of any claim, and (c)
        reasonable assistance in connection with such defense and settlement (at
        the Indemnifying Party’s expense). The Indemnified Party may participate
        in the defense or settlement of such a claim with counsel of its own
        choice and at its own expense; however, the Indemnifying Party shall not
        enter into any settlement agreement that imposes any obligation on the
        Indemnified Party without the Indemnified Party’s express prior written
        consent.
      </Graf>
      <Subheading>13. Limits of Liability</Subheading>
      <Graf>
        EXCEPT WITH RESPECT TO DAMAGES ARISING FROM A PARTY’S GROSS NEGLIGENCE,
        A PARTY’S WILLFUL MISCONDUCT, UNPAID AMOUNTS OWED TO SAUCEY BY MERCHANT
        IN EXCESS OF THE BELOW LIMIT, AMOUNTS PAYABLE TO THIRD PARTIES UNDER A
        PARTY’S INDEMNIFICATION OBLIGATIONS SET FORTH IN THESE TERMS, OR A
        PARTY’S BREACH OF ITS CONFIDENTIALITY OBLIGATIONS UNDER THESE TERMS, TO
        THE EXTENT PERMITTED BY APPLICABLE LAW: (A) IN NO EVENT WILL EITHER
        PARTY BE LIABLE FOR ANY CLAIM FOR ANY INDIRECT, WILLFUL, PUNITIVE,
        INCIDENTAL, EXEMPLARY, SPECIAL OR CONSEQUENTIAL DAMAGES, FOR LOSS OF
        BUSINESS PROFITS, HARM TO GOODWILL, OR DAMAGES FOR LOSS OF BUSINESS OF
        MERCHANT OR AY THIRD PARTY ARISING OUT OF THE AGREEMENT, OR LOSS OR
        INACCURACY OF DATA OF ANY KIND, WHETHER BASED ON CONTRACT, TORT OR ANY
        OTHER LEGAL THEORY, EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES; AND (B) EACH PARTY’S MAXIMUM AGGREGATE
        LIABILITIES RELATED TO OR IN CONNECTION WITH THE AGREEMENT SHALL NOT
        EXCEED THE TOTAL AMOUNT PAID OR PAYABLE BY ONE PARTY TO THE OTHER PARTY
        IN THE TWELVE (12) MONTH PERIOD IMMEDIATELY PRECEDING THE INCIDENT
        GIVING RISE TO THE LIABILITY. THE FOREGOING DISCLAIMER SHALL NOT APPLY
        TO THE EXTENT PROHIBITED BY LAW.
      </Graf>
      <Subheading>14. Insurance</Subheading>
      <Graf>
        During the Term and for one year after, each Party will maintain
        adequate insurance in amounts not less than as required by law or that
        is common practice in such Party’s business. Upon request, each Party
        will provide the other with current evidence of coverage. Such insurance
        shall not be cancelled or materially reduced without thirty (30) days
        prior written notice. In no event shall the limits of any insurance
        policy be considered as limiting the liability of a Party under the
        Agreement.
      </Graf>
      <Subheading>15. Term and Termination</Subheading>
      <Graf>
        These Terms will commence on the Effective Date (or Merchant’s first use
        of the Saucey Platform Services if the Sign-Up Agreement is not
        executed) and the term of these Terms will be one (1) year (the “Initial
        Term”) and upon the expiration of the Initial Term will automatically
        renew for successive one (1) year terms (each, a “Renewal Term” and
        together with the Initial Term, the “Term”) subject to termination in
        accordance with the terms of these Terms. Either Party may terminate
        these Terms at any time with or without cause by giving thirty (30)
        days’ prior written notice of termination to the other Party; provided,
        that if the Sign-Up Agreement is terminated in accordance with its terms
        or otherwise expires, these Terms shall terminate on such date that the
        Sign-Up Agreement is terminated or expires, as the case may be. All
        payment obligations and Sections 1, 2, 7-9, 11-14, this last sentence of
        15, 16-17, and 19 will survive the expiration or termination of these
        Terms.
      </Graf>
      <Subheading>16. Notice</Subheading>
      <Graf>
        Any and all notices permitted or required to be given hereunder will be
        sent to the address listed below, or such other address as may be
        provided, and deemed duly given: (a) upon actual delivery, if delivery
        is by hand; or (b) one (1) day after being sent by overnight courier,
        charges prepaid; or (c) by electronic mail to the designated recipient.
        Notices to Saucey should be provided to Saucey, Inc., Attn: Legal, 925
        N. La Brea Ave. 4th Floor, West Hollywood, CA 90038. Notices to Merchant
        should be provided to the address provided by Merchant. The Parties
        agree that all legal documents (including complaints and subpoenas)
        directed to Saucey will be served on Saucey’s registered agent for
        service of process.
      </Graf>
      <Subheading>17. Dispute Resolution and Arbitration</Subheading>
      <Graf>
        <ol type="a">
          <li>
            Arbitration. Any dispute, whether contractual or otherwise, arising
            out of or in connection with the Agreement or these dispute
            resolution procedures, including any question regarding its
            existence, performance, validity, or termination, will be referred
            to and finally resolved by arbitration administered by JAMS in
            accordance with its Comprehensive Arbitration Rules and Procedures
            (the “JAMS Rules”), which are deemed to be incorporated by reference
            into this clause. The Parties agree that the arbitrator
            (“Arbitrator”), and not any federal, state, or local court or
            agency, shall have exclusive authority to resolve any disputes
            relating to the interpretation, applicability, enforceability or
            formation of the Agreement, including any claim that all or any part
            of the Agreement is void or voidable. The Arbitrator shall also be
            responsible for determining all threshold arbitrability issues,
            including issues relating to whether the Agreement is unconscionable
            or illusory and any defense to arbitration, including waiver, delay,
            laches, or estoppel. In the event of a dispute, controversy or claim
            arising out of or relating in any way to the Agreement, the
            complaining Party shall notify the other Party in writing thereof.
            Within thirty (30) days of such notice, representatives of both
            Parties shall attempt to resolve the dispute in good faith. Should
            the dispute not be resolved within thirty (30) days after such
            notice, the complaining Party shall seek remedies exclusively
            through arbitration. Furthermore, the Parties agree:
            <ol type="i">
              <li>
                The Arbitrator’s award will be final and binding and judgment on
                the award rendered by the Arbitrator may be entered in any court
                having jurisdiction thereof, provided that any award may be
                confirmed in a court of competent jurisdiction.
              </li>
              <li>
                A Party who desires to initiate arbitration must provide the
                other party with a written Demand for Arbitration as specified
                in the JAMS Rules.
              </li>
              <li>
                The seat, or legal place, of arbitration will be Los Angeles,
                California, USA or the JAMS location closest to the Complaining
                Party’s place of business.
              </li>
              <li>
                The language to be used in the arbitral proceedings will be
                English.
              </li>
              <li>
                The arbitral tribunal will be composed of a sole arbitrator,
                which shall be nominated and appointed by JAMS in accordance
                with the JAMS Rules.
              </li>
              <li>
                To the extent permitted by applicable law, the Parties agree to
                keep all materials related to the dispute, including the
                existence of the dispute itself, content of the arbitration, and
                all the submissions by the parties in the arbitration and awards
                rendered by the arbitral tribunal, confidential.
              </li>
              <li>
                This agreement to arbitrate will not preclude the Parties from
                seeking provisional remedies from a court of competent
                jurisdiction. The Parties each retain the right to seek
                injunctive or other equitable relief in a court of competent
                jurisdiction to prevent the actual or threatened infringement,
                misappropriation or violation of a Party’s copyrights,
                trademarks, trade secrets, patents or other intellectual
                property rights.
              </li>
              <li>
                Neither Party may bring any class, collective, or representative
                action against the other Party, and will preclude a Party from
                participating in or recovering relief under any current or
                future class, collective, consolidated, or representative action
                brought against the other Party by someone else.
              </li>
              <li>
                Each Party shall pay its own proportionate share of Arbitrator
                fees and expenses plus and expenses of JAMS. The Arbitrator
                shall be entitled to award the foregoing arbitration and
                administrative fees and expenses as damages in his/her
                discretion.
              </li>
              <li>
                Notwithstanding any choice of law or other provision in the
                Agreement, the Parties agree and acknowledge that the Agreement
                evidences a transaction involving interstate commerce and that
                the Federal Arbitration Act, 9 U.S.C. § 1 et seq. (“FAA”), will
                govern its interpretation and enforcement and proceedings
                pursuant thereto. It is the intent of the Parties that the FAA
                and JAMS Rules shall preempt all state laws to the fullest
                extent permitted by law. If the FAA and JAMS Rules are found to
                not apply to any issue that arises under the Agreement or the
                enforcement thereof, then that issue shall be resolved under the
                laws of the state of California.
              </li>
            </ol>
          </li>
          <li>
            <Graf>
              Waiver of Jury Trial. Each Party hereby waives to the fullest
              extent permitted by applicable law, any right it may have to a
              trial by jury of any arbitrable claim under this Agreement and in
              connection with the enforcement of an arbitral award rendered
              pursuant to this agreement. Each Party (i) certifies that no
              representatives, agent or attorney of any other party has
              represented, expressly or otherwise, that such other Party would
              not, in the event of such litigation, seek to enforce the
              foregoing waiver and (ii) acknowledges that it and the other Party
              hereto have been induced to enter into the Agreement.
            </Graf>
          </li>
        </ol>
      </Graf>

      <Subheading>18. Diversity and Inclusion</Subheading>
      <Graf>
        {/*  I don't know why I have to wrap it in <Graf> twice but it doesn't format correctly if I don't */}
        <Graf>
          Merchant will not, in its use of the Saucey Platform Services or the
          Saucey App, discriminate against any customer, employee, contractor or
          other person or individual on the basis of race, color, gender,
          pregnancy, marital status, familial status, sexual orientation, gender
          identity or expression, religion, ancestry, national origin,
          disability, or age except that programs may target beneficial services
          for specific participant groups, as agreed upon between Saucey and
          Merchant. Merchant acknowledges and agrees that upon Saucey’s receipt
          of evidence of Merchant’s discrimination under any of these
          categories, Saucey will have the right to immediately terminate the
          Agreement following notice to Merchant.
        </Graf>
      </Graf>
      <Subheading>19. Additional Terms</Subheading>
      <Graf>
        As set forth in the Sign-Up Agreement, the Sign-Up Agreement and these
        Terms constitute an integrated agreement between the Parties, which
        supersedes all prior agreements and communications of the Parties, oral
        or written, with respect to the subject matter hereof. Each Party hereby
        acknowledges that it has been given the opportunity to have its
        independent counsel review the Agreement prior to execution and/or
        acceptance. Each Party represents and warrants that it has the full
        right, power, and authority to enter into and perform its obligations
        under the Agreement. The failure of either Party to enforce, at any time
        or for any period of time, the provisions in the Agreement, will not be
        construed as a waiver of such provision and will in no way affect that
        Party’s right to enforce such provisions. Merchant may not assign the
        Agreement in whole or in part without Saucey’s prior written consent.
        Saucey may freely assign the Agreement or any portion thereof. The
        Agreement is binding upon, and inures to the benefit of, the employees,
        representatives, agents, affiliates, franchisors, franchisees, and
        permitted successors and assigns of each Party, but shall not confer any
        rights or remedies upon any third party. In the Agreement, “including”
        means “including, without limitation.” If any provision of the Agreement
        is held to be invalid, illegal or unenforceable for any reason, such
        invalidity, illegality or unenforceability will not affect any other
        provisions of the Agreement, and the Agreement will be construed as if
        such invalid, illegal or unenforceable provision had never been
        contained here.
      </Graf>
    </Article>
  );
}
